import React from "react";

const EuroAmount = ({ row }) => {
  return <div>{row?.euroAmount?.toLocaleString()}</div>;
};

export default EuroAmount;
